// extracted by mini-css-extract-plugin
export default {"modal-tariff-card":"r1aU8","tariff-card-body":"mz7lJ","reset-heading":"cX6RN","buttons-group":"dqhQY","button-accept":"BABp4","modal-description":"RpOtt"};